const societyQualitiesActionTypes = {
  FETCH_SOCIETY_QUALITIES_START: 'FETCH_SOCIETY_QUALITIES_START',
  FETCH_SOCIETY_QUALITIES_SUCCESS: 'FETCH_SOCIETY_QUALITIES_SUCCESS',
  FETCH_SOCIETY_QUALITIES_FAILURE: 'FETCH_SOCIETY_QUALITIES_FAILURE',
  FETCH_SOCIETY_QUALITIES_FINISHED: 'FETCH_SOCIETY_QUALITIES_FINISHED'
};

export default societyQualitiesActionTypes;
